export default __webpack_public_path__ + "static/logos-eb755f5d7761ee7ad04a3b49bc18f247.svg";